import { usePage, router } from "@inertiajs/react";
import { AlertTriangle } from "lucide-react";

/**
 * A persistent banner shown at the top of every page when a platform admin is
 * impersonating another user. Rendered conditionally in the Inertia setup
 * (inertia.jsx) so it appears regardless of which layout the page uses.
 */
export default function ImpersonationBanner() {
  const { impersonation } = usePage().props;

  if (!impersonation?.active) return null;

  const handleStop = () => {
    router.delete(impersonation.stop_path);
  };

  // Rendered in normal flow at the top of the document so it pushes the
  // page layout down — `fixed` would overlap the sidebar/header instead
  // of making room for itself.
  return (
    <div className="relative z-[100] bg-warning text-foreground shadow-sm">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-center gap-3 text-sm font-medium">
        <AlertTriangle className="h-4 w-4 shrink-0" />
        <span>
          You are impersonating <strong>{impersonation.target_name}</strong>
        </span>
        <button
          onClick={handleStop}
          className="underline underline-offset-2 hover:no-underline font-semibold"
        >
          Stop impersonating
        </button>
      </div>
    </div>
  );
}
